// extracted by mini-css-extract-plugin
module.exports = {"disabledRow":"AttributeRow_disabledRow_3kK22"};